import React from 'react';
import { get } from 'lodash';
import LocaleSelect from '../../../core/form/LocaleSelect';
import Table from '../../../core/form/Table';
import PropTypes from 'prop-types';

const ImportCsvDialogPreviewScene = (props) => (
  <div>
    {props.currentScene === 'PREVIEW' && (
      <LocaleSelect
        required
        label="The locale which will receive the value from the third column in the below table:"
        disabled={props.submitting}
        value={get(props.values, 'locale', '')}
        onChange={(value) => props.onChange('locale', value)}
        errorText={get(props.errors, 'locale', null)}
      />
    )}
    {props.currentScene === 'IMPORT' && (
      <span style={{ marginBottom: '15px', display: 'block' }}>
        Do you really want to confirm these values to <b>{get(props.values, 'locale', 'selected locale')}</b>?
      </span>
    )}
    <Table
      showTableCount={false}
      scroll={{ x: 'max-content', y: 300 }}
      columns={[
        {
          label: 'Type',
          path: 'Type',
          width: '170px',
        },
        {
          label: 'Key',
          path: 'Key',
          width: '200px',
        },
        {
          label: 'English',
          path: 'English',
          width: '200px',
        },
        {
          label: props.currentScene === 'PREVIEW' ? 'Language' : get(props.values, 'locale', ''),
          width: '200px',
          render: (value) => value[Object.keys(value)[3]],
        },
      ]}
      rows={get(props.values, 'previewData', [])}
    />
  </div>
);

ImportCsvDialogPreviewScene.propTypes = {
  values: PropTypes.object,
  currentScene: PropTypes.oneOf(['PREVIEW', 'IMPORT']),
};

export default ImportCsvDialogPreviewScene;
